import { render, staticRenderFns } from "./SearchMedications.vue?vue&type=template&id=a3c8b8cc"
import script from "./SearchMedications.vue?vue&type=script&lang=js"
export * from "./SearchMedications.vue?vue&type=script&lang=js"
import style0 from "./SearchMedications.vue?vue&type=style&index=0&id=a3c8b8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports